console.warn(
  '[tavily] This package is deprecated. Please use @tavily/core instead:\n' +
    '  npm install @tavily/core\n' +
    '  https://www.npmjs.com/package/@tavily/core'
)

export * from '@tavily/core'
